import { render, staticRenderFns } from "./FileItemCard.vue?vue&type=template&id=6496e32e&"
import script from "./FileItemCard.vue?vue&type=script&lang=js&"
export * from "./FileItemCard.vue?vue&type=script&lang=js&"
import style0 from "./FileItemCard.vue?vue&type=style&index=0&id=6496e32e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports